import script from "./PinIcon18.vue?vue&type=script&setup=true&lang=ts"
export * from "./PinIcon18.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__